import React from 'react'
import { observer } from 'mobx-react-lite'
import { fromUnixTime } from 'date-fns/fromUnixTime'
import { getUnixTime } from 'date-fns/getUnixTime'
import { isValid } from 'date-fns/isValid'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { DatePicker, DateValidationError } from '@mui/x-date-pickers'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { ListItemAction, useGlobalCopyStore, useGoalStore, useUserStore } from '../../../common'
import { DATE_FORMATS_INTL, formatDate } from '../../../core/constants'
import { Goal } from '../../../core'

interface BirthdayActionProps {
  goal: Goal
}

export const BirthdayAction = observer(({ goal }: BirthdayActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { user, updateUser } = useUserStore()
  const { setAlert } = useGoalStore()

  const [birthday, setBirthday] = React.useState<Date | null>(fromUnixTime(user.birthday ?? 0))
  const [error, setError] = React.useState<DateValidationError>(null)

  const isDisabled = goal.is_complete

  const handleSave = async () => {
    if (birthday && isValid(birthday)) {
      await updateUser({ ...user, birthday: getUnixTime(birthday) })
      setAlert(copy.alert_goal_updated_birthday)
    }
  }

  return (
    <ListItemAction
      isDisabled={isDisabled}
      isSaveDisabled={Boolean(error)}
      label={copy.details_birthday}
      onSave={handleSave}
      primaryText={copy.details_birthday}
      secondaryText={`${formatDate(fromUnixTime(user.birthday ?? 0), DATE_FORMATS_INTL.MONTH_DAY_YEAR)}`}
      zeroStateText={!goal.guid && !user.birthday ? copy.add_birthday : undefined}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
          label={copy.details_birthday}
          onChange={setBirthday}
          onError={(error) => setError(error)}
          sx={{ width: '100%' }}
          value={birthday}
        />
      </LocalizationProvider>
    </ListItemAction>
  )
})
